/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types */

/*
 * javascript important dependencies (must be locked to these versions that are known to work together):
 *
 * jquery 3.7.1
 * jquery-ui 1.13.2
 * jquery-ui-dist 1.13.2
 * jquery-contextmenu 2.9.0
 * d3 5.16.0
 * bootstrap 4.5.3
 * fontawesome 5.12.1
 *
 */

import { BrowserModule }             from '@angular/platform-browser';
import { BrowserAnimationsModule }   from '@angular/platform-browser/animations';
import { NgOptimizedImage }          from "@angular/common";
import {
  Injector,
  NgModule
}                                    from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi }     from '@angular/common/http';

import {
  FormsModule,
  ReactiveFormsModule
}                                    from '@angular/forms';

import { AppComponent          }     from './components/app.component';
import {
  RouterModule,
}     from '@angular/router';

import { AppRouting            }     from './app.routing';
import { IDEComponent          }     from './screens/ide/ide.component';
import { LoginComponent        }     from './screens/login/login.component';
import { RegisterComponent     }     from './screens/register/register.component';
import { AuthHeaderStamp       }     from './helpers/auth.header.stamp';
/*
import { fakeBackendProvider   }     from './helpers/fake.backend';
import { dockerBackendProvider }     from './helpers/docker.backend';
 */
import { AdminToolbar          }     from '@/screens/administration/admin.toolbar';
import { AdminSidebar          }     from '@/screens/administration/admin.sidebar';
import { AdminFooter           }     from '@/screens/administration/admin.footer';
import { AlertComponent        }     from './components/alert.component';
import { UserDropdownComponent }     from './gui/menus/user.dropdown.component';
import { ModalComponent        }     from './components/modal.component';
import { ProfilePageComponent  }     from './screens/profile/profile.page.component';
import { AdminPageComponent    }     from './screens/administration/admin.page.component';
import { UserListPageComponent }     from './screens/administration/user.list.page.component';
import { UserDetailPageComponent   } from './screens/administration/user.detail.page.component';
import { PendingUsersPageComponent } from './screens/administration/pending.users.page.component';
import { ApproveUserPageComponent  } from './screens/administration/approve.user.page.component';
import { NewUserPageComponent      } from './screens/administration/new.user.page.component';
import { MainMenuComponent     }     from './gui/menus/main.menu.component';
import { OnlineDropupMenu }          from './gui/menus/online.dropup.menu';
import { TaskProgressComponent }     from './components/task.progress.component';
import { SimulateButtonComponent }   from './gui/menus/simulate.button.component';
import { ProjectButtonComponent }    from './gui/menus/project.button.component';
import { PropertiesButtonComponent } from './gui/menus/properties.button.component';

import { ScenarioBrowserComponent }  from '@/components/scenario.browser.component';
import { ConnectionViewerComponent}  from '@/components/connection.viewer.component';
import { Tabs }                      from './components/tabs';
import { Tab }                       from './components/tab';
import { DwellTable }                from './screens/ide/scenariobrowser/dwell.table';
import { TimeTable }                 from './screens/ide/scenariobrowser/time.table';
import { TrainTable}                 from './screens/ide/scenariobrowser/train.table';
import { PlantTable }                from './screens/ide/scenariobrowser/plant.table';

import { ThreeStringViewer }         from './screens/ide/stringviewer/three.string.viewer';
import { StringViewerComponent }     from '@/components/string.viewer.component';
import { UserLogViewerComponent }    from '@/components/user.log.viewer.component';
import { UserLogComponent }          from '@/components/user.log.component';
import { JobsViewerComponent }       from '@/components/jobs.viewer.component';
import { KPITableViewerComponent }   from '@/components/k.p.i.table.viewer.component';
import { WorkBloxEditor }            from './screens/ide/workblox/work.blox.editor';
import { WorkBloxSummaryTable }      from './screens/ide/workblox/work.blox.summary.table';
import { WorkBloxSummaryGraph }      from './screens/ide/workblox/work.blox.summary.graph';
import { WorkBloxEditorComponent }   from '@/components/work.blox.editor.component';
import { DiversionEditor }           from './screens/ide/diversion/diversion.editor';
import { DiversionSummaryTable }     from './screens/ide/diversion/diversion.summary.table';
import { DiversionEditorComponent }  from '@/components/diversion.editor.component';
import { TSOEditor }                 from './screens/ide/tso/t.s.o.editor';
import { TSOSummaryTable }           from './screens/ide/tso/t.s.o.summary.table';
import { TSOEditorComponent }        from '@/components/t.s.o.editor.component';
import { BatchViewerComponent }      from "@/components/batch.viewer.component";
import { BatchViewer }               from "./screens/ide/batchviewer/batch.viewer";
import { RegressionViewerComponent } from "@/components/regression.viewer.component";
import { RegressionViewer }          from "./screens/ide/regressionviewer/regression.viewer";

import { MatToolbarModule }          from '@angular/material/toolbar';
import { MatSidenavModule }          from '@angular/material/sidenav';
import { MatIconModule }             from '@angular/material/icon';
import { MatGridListModule }         from '@angular/material/grid-list';
import { MatListModule }             from "@angular/material/list";
import { MatCardModule }             from "@angular/material/card";
import { MatTooltipModule }          from "@angular/material/tooltip";
import { MatFormFieldModule }        from "@angular/material/form-field";

import { AvatarModule }              from 'primeng/avatar';
import { KnobModule }                from 'primeng/knob';
import { TableModule }               from 'primeng/table';
import { ButtonModule }              from 'primeng/button';
import { TagModule }                 from 'primeng/tag';
import { PasswordModule }            from 'primeng/password';
import { DividerModule }             from 'primeng/divider';
import { InputNumberModule }         from 'primeng/inputnumber';
import { SplitterModule }            from 'primeng/splitter';
import { DropdownModule }            from 'primeng/dropdown';
import { DataViewModule }            from 'primeng/dataview';
import { ToolbarModule }             from 'primeng/toolbar';
import { MultiSelectModule }         from 'primeng/multiselect';
import { CheckboxModule }            from 'primeng/checkbox';
import { DatePickerModule }          from 'primeng/datepicker';
import { SelectButton }              from 'primeng/selectbutton';
import { provideAnimationsAsync }    from '@angular/platform-browser/animations/async';
import { providePrimeNG }            from 'primeng/config';
import Aura                          from '@primeng/themes/aura';

import 'ag-grid-community';
import 'ag-grid-enterprise';

import { LicenseManager } from  'ag-grid-enterprise'

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-081278}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Iron_Road_Software_&_Simulation_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Project_Manager}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Project_Manager}_need_to_be_licensed___{Project_Manager}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{1_November_2026}____[v3]_[01]_MTc5MzQ5MTIwMDAwMA==90e6077455236025dd14d073589cdba1");

/*
 * force the project element classes to all be loaded at least once, so they are known to the
 * ProjectElementFactory.
 *
 * note: we use some extra import syntax here to force TypeScript to include the class, even though
 * it's not directly being used:
 *
 * ref: https://github.com/microsoft/TypeScript/issues/9191
 *
 * we don't set global compiler flags to force TypeScript to keep all unused stuff...that causes
 * all kinds of other problems.
 *
 */

import {SimulationElement} from './models/project/simulation.element';
import './models/project/simulation.element';
SimulationElement.requireType();

import {BlobElement} from './models/project/blob.element';
import './models/project/blob.element';
BlobElement.requireType();

import {UserCommandsElement} from './models/project/user.commands.element';
import './models/project/user.commands.element';
UserCommandsElement.requireType();

import {UserCommandsResultElement} from './models/project/user.commands.result.element';
import './models/project/user.commands.result.element';
UserCommandsResultElement.requireType();

import {DiamondCrossingsElement} from './models/project/diamond.crossings.element';
import './models/project/diamond.crossings.element';
DiamondCrossingsElement.requireType();

import {DiamondCrossingsResultElement} from './models/project/diamond.crossings.result.element';
import './models/project/diamond.crossings.result.element';
DiamondCrossingsResultElement.requireType();

import {PropertyElement} from './models/project/property.element';
import './models/project/property.element';
PropertyElement.requireType();

import {DimensionElement} from './models/project/dimension.element';
import './models/project/dimension.element';
DimensionElement.requireType();

import {InputsElement} from './models/project/inputs.element';
import './models/project/inputs.element';
InputsElement.requireType();

import {ManifestElement} from './models/project/manifest.element';
import './models/project/manifest.element';
ManifestElement.requireType();

import {SnapshotsElement} from './models/project/snapshots.element';
import './models/project/snapshots.element';
SnapshotsElement.requireType();

import {SimulationGroupElement} from './models/project/simulation.group.element';
import './models/project/simulation.group.element';
SimulationGroupElement.requireType();

import {ResultsElement} from './models/project/results.element';
import './models/project/results.element';
ResultsElement.requireType();

import {RootElement} from './models/project/root.element';
import './models/project/root.element';
RootElement.requireType();

import {LineSimJobElement} from './models/project/line.sim.job.element';
import './models/project/line.sim.job.element';
LineSimJobElement.requireType();

import {BatchSimJobElement} from './models/project/batch.sim.job.element';
import './models/project/batch.sim.job.element';
BatchSimJobElement.requireType();

import {LineSimElement} from './models/project/line.sim.element';
import './models/project/line.sim.element';
LineSimElement.requireType();

import {RegressionElement} from './models/project/regression.element';
import './models/project/regression.element';
RegressionElement.requireType();

import {CorridorGroupElement} from './models/project/corridor.group.element';
import './models/project/corridor.group.element';
CorridorGroupElement.requireType();

import {KPIElement} from './models/project/k.p.i.element';
import './models/project/k.p.i.element';
KPIElement.requireType();

import {KPIXElement} from './models/project/k.p.i.x.element';
import './models/project/k.p.i.x.element';
KPIXElement.requireType();

import {KPITableElement} from './models/project/k.p.i.table.element';
import './models/project/k.p.i.table.element';
KPITableElement.requireType();

import {LocomotiveModelElement} from './models/project/locomotive.model.element';
import './models/project/locomotive.model.element';
LocomotiveModelElement.requireType();

import {LocomotiveModelResultElement} from './models/project/locomotive.model.result.element';
import './models/project/locomotive.model.result.element';
LocomotiveModelResultElement.requireType();

import {BatchGroupElement} from './models/project/batch.group.element';
import './models/project/batch.group.element';
BatchGroupElement.requireType();

import {CorridorBatchElement} from './models/project/corridor.batch.element';
import './models/project/corridor.batch.element';
CorridorBatchElement.requireType();

import {BatchSummariesElement} from './models/project/batch.summaries.element';
import './models/project/batch.summaries.element';
BatchSummariesElement.requireType();

import {BatchMeasureElement} from './models/project/batch.measure.element';
import './models/project/batch.measure.element';
BatchMeasureElement.requireType();

/*
 * force the project classes to all be loaded at least once, so they are known to the
 * ProjectFactory.
 *
 * note: we use some extra import syntax here to force TypeScript to include the class, even though
 * it's not directly being used:
 *
 * ref: https://github.com/microsoft/TypeScript/issues/9191
 *
 * we don't set global compiler flags to force TypeScript to keep all unused stuff...that causes
 * all kinds of other problems.
 *
 */

import {BatchSimulationProject} from './models/batch.simulation.project';
import './models/batch.simulation.project';
BatchSimulationProject.requireType();

import {SimulationProject} from './models/simulation.project';
import './models/simulation.project';
BatchSimulationProject.requireType();

import {LibraryProject} from './models/project/library.project';
import './models/project/library.project';
BatchSimulationProject.requireType();

/* bring in the service locator, we have to set this up so we can "see" the Injector */

import {ServiceLocator} from "@/services/service.locator";
import {AgGridModule} from "ag-grid-angular";


/* regular Angular module declarations etc. */

@NgModule({ declarations: [
        AppComponent,
        IDEComponent,
        LoginComponent,
        RegisterComponent,
        AlertComponent,
        UserDropdownComponent,
        ProfilePageComponent,
        AdminPageComponent,
        UserListPageComponent,
        UserDetailPageComponent,
        PendingUsersPageComponent,
        ApproveUserPageComponent,
        NewUserPageComponent,
        MainMenuComponent,
        ProjectButtonComponent,
        PropertiesButtonComponent,
        OnlineDropupMenu,
        TaskProgressComponent,
        SimulateButtonComponent,
        ModalComponent,
        ScenarioBrowserComponent,
        ConnectionViewerComponent,
        AdminToolbar,
        AdminSidebar,
        AdminFooter,
        Tabs,
        Tab,
        TimeTable,
        TrainTable,
        PlantTable,
        DwellTable,
        ThreeStringViewer,
        StringViewerComponent,
        UserLogViewerComponent,
        UserLogComponent,
        JobsViewerComponent,
        KPITableViewerComponent,
        WorkBloxEditor,
        WorkBloxSummaryTable,
        WorkBloxSummaryGraph,
        WorkBloxEditorComponent,
        DiversionEditorComponent,
        DiversionEditor,
        DiversionSummaryTable,
        TSOEditorComponent,
        TSOEditor,
        TSOSummaryTable,
        BatchViewerComponent,
        BatchViewer,
        RegressionViewerComponent,
        RegressionViewer
    ],
    exports: [
        RouterModule,
    ],
    /* which component is the entry point? */
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRouting,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatCardModule,
        MatGridListModule,
        MatTooltipModule,
        MatFormFieldModule,
        KnobModule,
        TableModule,
        ButtonModule,
        TagModule,
        AvatarModule,
        PasswordModule,
        DividerModule,
        InputNumberModule,
        SplitterModule,
        DropdownModule,
        DataViewModule,
        ToolbarModule,
        MultiSelectModule,
        CheckboxModule,
        DatePickerModule,
        SelectButton,
        NgOptimizedImage,
        AgGridModule
  ],
  providers: [
        /* dockerBackendProvider, */
        /* fakeBackendProvider, */
        { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderStamp, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
            preset: Aura
          }
        })
    ]
})

export class AppModule {

  constructor(private injector: Injector) {

    /* tell the service locator what injector to use */

    ServiceLocator.injector = injector;
  }

}
